var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongCalendarCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2852 30.4318C30.7755 43.8225 19.929 44.1274 10.7516 44.3854C9.64216 44.4166 8.55711 44.4471 7.5 44.5V40C23 42.5 32 35.5 41 24C47.1895 31.958 53.1261 36.2182 60.0001 37.3341V40.6136C53.6955 39.8768 45.8345 37.1181 41.2852 30.4318Z",
    fill: "#12B16E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2852 30.432L41.6986 30.1507L41.314 29.5854L40.8919 30.1233L41.2852 30.432ZM7.5 44.5002H7V45.0258L7.52497 44.9996L7.5 44.5002ZM7.5 40.0002L7.57962 39.5066L7 39.4131V40.0002H7.5ZM41 24.0002L41.4809 23.8634L41.212 22.918L40.6062 23.692L41 24.0002ZM41 24.0002L40.5192 24.1373L40.5458 24.2308L40.6054 24.3075L41 24.0002ZM60.0001 37.3343H60.5001V36.9089L60.0802 36.8407L60.0001 37.3343ZM60.0001 40.6138L59.9421 41.1104L60.5001 41.1756V40.6138H60.0001ZM40.8919 30.1233C35.6923 36.7482 30.4313 40.112 25.3559 41.8608C20.2656 43.6149 15.333 43.7566 10.7376 43.8858L10.7657 44.8854C15.3476 44.7566 20.427 44.6169 25.6817 42.8063C30.9513 40.9905 36.3684 37.5065 41.6785 30.7407L40.8919 30.1233ZM10.7376 43.8858C9.62916 43.917 8.53855 43.9476 7.47503 44.0008L7.52497 44.9996C8.57567 44.947 9.65517 44.9167 10.7657 44.8854L10.7376 43.8858ZM8 44.5002V40.0002H7V44.5002H8ZM7.42038 40.4938C15.2678 41.7595 21.5062 40.6227 26.9255 37.6899C32.3285 34.766 36.8794 30.0767 41.3938 24.3084L40.6062 23.692C36.1206 29.4237 31.6715 33.9844 26.4495 36.8105C21.2438 39.6277 15.2322 40.7409 7.57962 39.5066L7.42038 40.4938ZM60.0802 36.8407C53.3811 35.7532 47.545 31.601 41.3948 23.6935L40.6054 24.3075C46.8342 32.316 52.8711 36.6835 59.92 37.8278L60.0802 36.8407ZM60.5001 40.6138V37.3343H59.5001V40.6138H60.5001ZM40.8718 30.7132C45.5367 37.5694 53.5667 40.3653 59.9421 41.1104L60.0581 40.1171C53.8242 39.3886 46.1323 36.6671 41.6986 30.1507L40.8718 30.7132Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4999 34H44.5C49.4609 38.7357 54.8306 40.6539 59.9999 41.2011V36.9202C56.2883 36.3037 54.0826 34.8624 51.4999 34Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38 34C29 45 16 44.5 7.5 44.5H7V40H7.5C24 41.5 28 36 31.5 34H38Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongCalendarCalls);
export default __webpack_public_path__ + "static/media/long_calendar_calls.377f6736ed1015f2414160b8dca67a98.svg";
export { ForwardRef as ReactComponent };